export default __webpack_public_path__ + "img/fleche_bas.01e26693.svg";